/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{padding-top:35px}.orderhistorytable[_ngcontent-%COMP%]{margin-bottom:30px;font-size:1rem}.orderhistorytable[_ngcontent-%COMP%]   .ordered-on[_ngcontent-%COMP%]{color:#999;font-size:.9rem}.orderhistorytable[_ngcontent-%COMP%]   .column-address-and-date[_ngcontent-%COMP%]{line-height:20px}"];
export { styles as styles };
